<ion-content>
  <div class="constrained-content">
    <ion-grid class="constrained-content">
      <ion-row>
        <ion-col size-md="4" size="12" class="settings-title-section">
          <h1><ion-icon name="alert-circle-outline"></ion-icon>Escalations</h1>
          <p class="subtitle">
            Define and manage types of escalations available to agents.
          </p>
        </ion-col>
        <ion-col size-md="8" size="12">
          <div class="flex-space-between" style="padding: 15px 5px 0 3px">
            <div class="button-container flexed-align-center">
              <ion-searchbar
                mode="ios"
                placeholder="Search..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilters()"
                class="rounded-search-bar"
              ></ion-searchbar>
            </div>

            <div class="button-container flexed-align-center">
              <ion-button (click)="createEscalationType()">
                <ion-icon name="add-outline"></ion-icon>
                <span class="text-with-left-icon hidden-sm">
                  Create escalation path
                </span>
              </ion-button>
            </div>
          </div>
          <ion-card class="outline-card" style="margin: 18px">
            <ngx-datatable
              class="material"
              columnMode="force"
              [limit]="100"
              [headerHeight]="50"
              [footerHeight]="50"
              [rowHeight]="50"
              [scrollbarH]="true"
              [rows]="filteredEscalationTypes"
              [reorderable]="true"
              [hidden]="!filteredEscalationTypes.length"
            >
              <ngx-datatable-column
                name="Name"
                prop="name"
                [minWidth]="100"
                [width]="100"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <a (click)="editEscalationType(row.id)">{{ value }}</a>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Description"
                prop="description"
                [minWidth]="300"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  {{ value }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Slack Channel"
                prop="slackChannelId"
                [minWidth]="120"
                [maxWidth]="120"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span *ngIf="row.slackChannel">{{
                    row.slackChannel?.name ?? PRIVATE_CHANNEL_NAME
                  }}</span>
                  <span *ngIf="!row.slackChannel">None</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column
                name="Created at"
                prop="createdAt"
                [minWidth]="120"
                [maxWidth]="120"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  {{ value | date: "M/d/yyyy" }}
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
            <div
              class="empty-state-container"
              *ngIf="!filteredEscalationTypes.length"
              style="margin: 40px 0"
            >
              <span class="placeholder-emoji">
                <ion-icon name="chatbubble-outline"></ion-icon>
                <ion-icon
                  name="arrow-forward-outline"
                  style="font-size: 2.6rem"
                ></ion-icon>
                <ion-icon name="alert-circle-outline"></ion-icon>
              </span>
              <h1 class="placeholder-title">Define an escalation path</h1>
              <p class="placeholder-subtitle">
                Create custom escalation paths and routing rules when a ticket
                needs to be escalated to different teams.
              </p>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
